// --------------------------------------------------------------
// Created On: 2021-09-01
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { CSVLink } from "react-csv";
import styles from "./CsvDownloadButton.module.scss";

// Button that downloads a CSV file.
export default function CsvDownloadButton(props: Props): Component {
  return (
    <CSVLink data={props.data} className={`${styles.body} ${props.className}`} filename={props.fileName}>
      {props.children}
    </CSVLink>
  );
}

interface Props {
  fileName: string;
  className?: string;
  data: string[][];
  children: string;
}
